import { getIframeUrl } from '../../../../videos';
import browser, { dom } from '../../../../browser';
import lockedContent from '../../locked-content';

function parseVideo(video, shouldLockVideos) {
  const iframeUrl = getIframeUrl(video.src);

  if (!iframeUrl) {
    return;
  }

  const iframe = browser.document.createElement('iframe');
  iframe.classList.add('oc-video__iframe');
  iframe.setAttribute('aria-labelledby', 'course-title');

  const iframeWrapper = browser.document.createElement('div');
  iframeWrapper.classList.add('oc-video');

  iframe.src = iframeUrl;
  iframe.setAttribute('allowFullScreen', '');

  if (shouldLockVideos) {
    lockedContent.lock.init(iframe, video, '/login?context=courseAccess');
  } else {
    iframeWrapper.appendChild(iframe);
    video.parentNode.insertBefore(iframeWrapper, video);
  }

  video.parentNode.removeChild(video);
}

function init(domContainer, shouldLockVideos = false) {
  const videosToParse = dom.nodeListToArray(domContainer.getElementsByTagName('video'));

  videosToParse.forEach((video) => parseVideo(video, shouldLockVideos));
}

export default {
  init,
  parseVideo,
};
